import React from 'react';
import { Icon } from 'src/components/ui/Icon';

type Length = number | string;
type ElementSize = [Length, Length];
type FontSize = Length;
type ClassNameIcon=string;
type Href=string;

export type ElementIconElement = {
  icons: {
    base: string
    size: FontSize
    paths: string[]
  },
  icon: ClassNameIcon,
  image: Href,
  size: ElementSize,
  fontSize: FontSize,
}

function ElementIcon({
  // Default to `{}` so an unset value (e.g. a workpage with no icon yet, or the
  // SelectImageField preview before a pick) renders the placeholder instead of
  // throwing "Cannot read properties of undefined (reading 'icons')".
  element: {
    icons, icon, image,
    size: elSize,
    fontSize: elFontSize
  } = {},
  size: propSize,
  fontSize: propFontSize
}: {
  element?: Partial<ElementIconElement>,
  size?: ElementSize,
  fontSize?: FontSize,
}){
  if (icons) {
    const size = propFontSize || elFontSize || icons.size;
    const style = size ? { fontSize: size } : {};

    return (
      <span className={icons.base} style={style}>
        {icons.paths.map((p, idx) => (
          <i key={idx} className={p} />
        ))}
      </span>
    );
  } else if (icon) {
    const size = propFontSize || elFontSize;
    // lucide icons default to 1em, so they scale with the surrounding
    // fontSize exactly like the old FA glyphs did.
    const style: React.CSSProperties = size ? { fontSize: size } : {};

    return <Icon name={icon} style={style} />;
  } else if (image) {
    const size = propSize || elSize;
    const style = size
      ? {
          width: size[0],
          height: size[1],
        }
      : {};

    return (
      <img
        // alt={image}
        src={image}
        style={style}
        className="img-responsive"
      />
    );
  } else {
    // Nothing chosen yet — show a neutral lucide placeholder so the picker
    // button reads as "pick an icon/image" instead of a broken <img>.
    const size = propFontSize || elFontSize;
    const style: React.CSSProperties = size ? { fontSize: size } : {};

    return <Icon name="image" className="opacity-40" style={style} />;
  }
}

export default ElementIcon;
